/**
 * The widget composer's keyboard contract (chat-experience 11, §4.0 D). It is the console's table
 * MINUS ArrowUp (Q8 — no edit-last on a customer surface) and MINUS Esc-stop (the widget has no Stop,
 * §0.1). Pure, so it is testable without mounting Chat.jsx.
 *
 * §4.0 D's two `streaming` rows (Enter no-ops, a "Press Esc to stop first" hint) assume a Stop this
 * surface does not have, so a visitor may still send while a reply streams — never freeze the field.
 *
 * @returns {"send" | "newline" | "dismiss" | null}
 */
export function composerKeyIntent(e) {
	if (!e || e.isComposing) return null;                                  // an IME candidate is being picked
	if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) return "send";     // Cmd/Ctrl+Enter always sends
	if (e.key === "Enter" && e.shiftKey) return "newline";                // the default — no preventDefault
	if (e.key === "Enter") return "send";
	if (e.key === "Escape") return "dismiss";                             // clears the inline error; text kept
	return null;                                                          // ArrowUp falls through by design (Q8)
}
